import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

export default class extends Controller {
  static targets = ['input'];

  connect() {
    const self = this;
    $(self.inputTargets).on('change', () => {
      self.element.submit();
    });
  }
}
